import { ReactElement } from 'react';
import { ADD_TO_CART_DISPLAY_TYPE, AddToCart } from '@client/cart/components/AddToCart';
import { useDeviceType } from '@client/common/hooks';
import { isMobile, isPhone } from '@client/common/utils/env';
import { AddToCompareAction } from '@client/product/components/ProductActions/AddToCompareAction';
import classNames from 'classnames';
import { Props } from './';
import './Actions.scss';

export const Actions = ({
  product,
  onAddToCart,
  isUserCertified,
  isAddToCompareEnabled,
  areActionsVisible = false,
  className,
}: Props): ReactElement => {
  const deviceType = useDeviceType();

  return (
    <ul className={classNames(
      'cds-List',
      'cds-List--Unstyled',
      'CartProduct-Actions',
      {
        'CartProduct-Actions--Mobile': isMobile(deviceType),
      },
      className,
    )}>
      {isAddToCompareEnabled && !isPhone(deviceType) && (
        <li className='CartProduct-Action'>
          <AddToCompareAction product={product} isVisible={areActionsVisible} />
        </li>
      )}

      <li className={classNames(
        'CartProduct-Action',
        'cds-ProductBox-Action-AddToCart',
        {
          'CartProduct-Action--Displayed': !isUserCertified,
        },
      )}
      >
        <AddToCart
          sku={product.sku}
          productName={product.name}
          reference={product.cart.reference || undefined}
          quantityAdding={product.cart.quantity}
          settings={product.settings || null}
          type={ADD_TO_CART_DISPLAY_TYPE.icon}
          isUserCertified={!!isUserCertified}
          isVisible={areActionsVisible}
          onClick={onAddToCart}
        />
      </li>
    </ul>
  );
};
